import { CPIFrequency, SelectOption } from 'models'

export const TIME_FRAME_OPTIONS: SelectOption[] = [
  {
    label: '1W',
    value: '1w'
  },
  {
    label: '1M',
    value: '1m'
  },
  {
    label: '3M',
    value: '3m'
  },
  {
    label: '6M',
    value: '6m'
  },
  {
    label: 'Past Year',
    value: '1y'
  },
  {
    label: 'Custom',
    value: 'custom'
  }
]

export const FREQUENCY_OPTIONS: SelectOption[] = [
  {
    label: 'Daily',
    value: CPIFrequency.Daily
  },
  {
    label: 'Weekly',
    value: CPIFrequency.Weekly
  },
  {
    label: 'Monthly',
    value: CPIFrequency.Monthly
  }
]
